import React, { FC, useMemo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { AlertRoundIcon, Asset } from '@clearcover/atlas';

import { ReportDetails, Stalled, StalledContent } from 'QuoteApp/components';
import { useAppContext } from 'QuoteApp/services/providers';

import styles from './styles.module.css';

export const Stopped: FC<RouteComponentProps> = () => {
  const { details } = useAppContext();

  const stopReasons = useMemo(() => {
    // TODO: Cleanup failureReasons once underwritingStops are deployed to prod
    const failureReasons = details.underwriting.failureReasons;
    const underwritingStops = details.underwriting.underwritingStops;
    if (failureReasons.length === underwritingStops.length) {
      return underwritingStops.map(stopReason => stopReason.errorMessage);
    }
    return failureReasons;
  }, [
    details.underwriting.failureReasons,
    details.underwriting.underwritingStops,
  ]);

  return (
    <Stalled testId="aqui-stalled-status-screen">
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <StalledContent variant="headline">
            Applicant is not a good fit.
          </StalledContent>
          <StalledContent>
            At least one driver does not currently pass our underwriting
            criteria, so we are unable to provide a quote. Please encourage the
            applicant to re-apply after any high-risk drivers have moved from
            the household, or any accidents or violations have been cleared from
            their driving record.
          </StalledContent>
          <StalledContent>
            If you believe the stop was made in error, we're here to help.
            Please contact Clearcover Support by chat or by phone at{' '}
            <a className={styles.supportLink} href="tel:8558092965">
              (855) 809-2965
            </a>
            .
          </StalledContent>
          {stopReasons.length > 0 && (
            <div
              className={styles.stopReasonWrapper}
              data-testid="stop-reasons-container"
            >
              <Asset
                icon={AlertRoundIcon}
                description="Stop reasons"
                height={20}
                width={20}
              />
              <div className={styles.stopReasonText}>
                <h5>
                  Reason
                  {stopReasons.length > 1 ? 's ' : ' '}
                  for Underwriting Stop
                </h5>
                <ul>
                  {stopReasons.map(reason => (
                    <li className={styles.stopReasonItem} key={reason}>
                      {reason}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
        <ReportDetails />
      </div>
    </Stalled>
  );
};
